import path from 'path'
import moment from 'moment'
import accounting from 'accounting'
// import config from '../config'

export default {
  install(Vue) {
    // Vue.directive('currency-format', {
    // 	bind(el, binding, vnode, oldVnode){
    // 		let opt = binding.expression
    // 		let val = parseFloat(el.innerHTML)
    // 		if (isNaN(val)){
    // 			return
    // 		}
    // 		el.innerHTML = accounting.formatMoney(val, opt.currency, opt.precision, opt.decimal, opt.thousand)
    // 	}
    // })

    Vue.prototype.$createCookie = function (name, value, days) {
      let expires = ''
      if (days) {
        let date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toUTCString()
      }
      document.cookie = name + '=' + value + expires + '; path=/'
    }
    Vue.prototype.$deleteCookie = function (tokenAlias) {
      document.cookie = tokenAlias + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;'
    }
    Vue.prototype.$getCookie = function (cName) {
      if (document.cookie.length > 0) {
        let cStart = document.cookie.indexOf(cName + '=')
        if (cStart !== -1) {
          cStart = cStart + cName.length + 1
          let cEnd = document.cookie.indexOf(';', cStart)
          if (cEnd === -1) {
            cEnd = document.cookie.length
          }
          return unescape(document.cookie.substring(cStart, cEnd))
        }
      }
      return ''
    }
    Vue.prototype.$formatMoney = accounting.formatMoney
    Vue.prototype.$formatDate = function (t) {
      return moment(t).format('DD/MM/YYYY')
    }
    Vue.prototype.$formatDateTime = function (t) {
      return moment(t).format('YYYY-MM-DD HH:mm')
    }
    Vue.prototype.$dateFromNow = function (t) {
      return moment(t).fromNow()
    }
    Vue.prototype.$getRouteName = function (raw) {
      if (raw === null) {
        return ''
      }
      return raw.substring(0, raw.indexOf('|') - 1)
    }
    Vue.prototype.$elementParentExists = function (el, parentSelector) {
      if (parentSelector === undefined) {
        return false
      }
      let p = el.parentElement
      if (p === null) {
        return false
      }
      while (p !== parentSelector) {
        p = p.parentElement
        if (p === null) {
          return false
        }
      }
      return true
    }
    Vue.prototype.$escapeHtml = function (str) {
      let entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;',
      }
      // return String(str).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
      // 	return entityMap[s]
      // })
      return String(str).replace(/[&<>"'`=/]/g, s => entityMap[s])
    }
    Vue.prototype.$range = function (start, end) {
      return [...Array(end - start).keys()].map(v => start + v)
    }
    Vue.prototype.$simplePair = function (pair) {
      if (pair.indexOf('.') !== -1) {
        return pair.split('.')[0]
      }
      return pair
    }
    Vue.prototype.$padNumber = function (number, width) {
      let c = +width + 1 - (number + '').length
      if (c < 0) {
        return number
      }
      return new Array(c).join('0') + number
    }
    Vue.prototype.$commaStringToArray = function (str) {
      return str.toString().split(',')
    }
    Vue.prototype.$priorityType = function (arr, key) {
      // arr must be an array
      // expecting string key
      if (!Array.isArray(arr) || key === '') {
        return arr
      }
      if (arr.length === 1) {
        return arr
      }
      let pos = arr.indexOf(key)
      if (pos > 0) {
        arr.splice(0, 0, arr.splice(pos, 1)[0])
      }
      return arr
    }
    Vue.prototype.$imgErr = function (event, type, identifier, id) {
      if (!event.target.dataset.imgfix) {
        let basename = path.basename(event.target.src)
        if (typeof identifier === 'undefined' || identifier === null) {
          identifier = basename.substring(3)
        }
        if (typeof id === 'undefined' || id === null) {
          id = basename.substring(0, 3)
        }
        event.target.src = this.$pkImg(type, identifier, id)
        event.target.dataset.imgfix = true
      }
    }
    Vue.prototype.$pkImg = function (type, identifier, id) {
      // if (identifier === null || identifier === '') {
      // 	return ''
      // }
      if (identifier !== null) {
        identifier = identifier.toLowerCase()
      }
      let suffix = ''
      if (identifier.indexOf('-') !== -1 && identifier.indexOf('-o') !== identifier.length - 2 && identifier !== 'ho-oh') {
        suffix = identifier.substring(identifier.indexOf('-'))
      }
      if (type === 'big') {
        return '/artwork/pokemon/240x240/' + this.$padNumber(id, 3) + identifier + '.png'
      }
      if (type === 'small') {
        return '/artwork/pokemon/64x64/' + this.$padNumber(id, 3) + identifier + '.png'
      }
      if (type === 'medium') {
        return '/artwork/pokemon/thumbs/' + this.$padNumber(id, 3) + identifier + '.png'
      }
      if (type === 'sprite-model') {
        return '/sprites/pokemon/model/' + id + suffix + '.png'
      }
      if (type === 'sprite-small') {
        return '/sprites/pokemon/small/' + identifier + '.png'
      }
      if (type === 'sprite') {
        return '/sprites/pokemon/' + id + suffix + '.png'
      }
      if (type === 'sprite-shiny') {
        // console.log('/sprites/pokemon/shiny/' + id + '.png')
        return '/sprites/pokemon/shiny/' + id + '.png'
      }
    }
    Vue.prototype.$addDecimal = function (number, position) {
      if (position > 5) {
        return NaN
      }
      return (number / Math.pow(10, position)).toFixed(position)
    }
    Vue.prototype.$genderRate = function (rate) {
      if (rate < 0) {
        return rate
      }
      // male
      return (rate / 8) * 100
    }
    Vue.prototype.$genderRateDescription = function (rate) {
      let c = this.$genderRate(rate)
      if (c < 0) {
        return 'Genderless'
      } else {
        return Math.abs(100 - c) + '% Male, ' + c + '% Female'
      }
    }
  },
}
